import script from "./AvaliacoesAlunos.vue?vue&type=script&setup=true&lang=js"
export * from "./AvaliacoesAlunos.vue?vue&type=script&setup=true&lang=js"

import "./AvaliacoesAlunos.vue?vue&type=style&index=0&id=bc8556a8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bc8556a8"]])

export default __exports__